import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import TableChartOutlinedIcon from '@mui/icons-material/TableChartOutlined';
import Box from '@mui/material/Box';
import { RedistrictingData, RedistrictingDataID, MapDrawerOpen } from "../../atom/atom"
import {
    useRecoilState
} from 'recoil';
import FlexTable from '../Tables/FlexTable';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ m: 1, overflow: "auto" }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function RedistrictingDataTabs() {
  const [redistrictingdata, setredistrictingdata] = useRecoilState(RedistrictingData)
  const [redistrictingdataid, setRedistrictingDataID] = useRecoilState(RedistrictingDataID)
  const [drawerOpen, setDrawerOpen] = useRecoilState(MapDrawerOpen);

  const handleChange = (event, newValue) => {
    setRedistrictingDataID(newValue);
  };

  const handleClose = (index) => {
    let newredistrictingdata = redistrictingdata.filter((_, i) => i !== index)
    setredistrictingdata(newredistrictingdata)
    if ((index - 1) >= 0) {
      setRedistrictingDataID(index - 1)
    } else if (newredistrictingdata.length > 0) {
      setRedistrictingDataID(0)
    } else {
      setRedistrictingDataID(null)
      setDrawerOpen(false)
    }
  };

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', display: "flex", justifyContent: 'space-between' }}>
        {redistrictingdataid === null ? 
        <Typography variant="body2" m="10px">No data to display</Typography>
        : <Tabs
        value={redistrictingdataid}
        onChange={handleChange}
        aria-label="basic tabs example"
        variant="scrollable"
        scrollButtons={false}
        >
            {redistrictingdata.map((data, index) => (
                <Tab key={index} label={(
                    <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
                      <TableChartOutlinedIcon fontSize="small" sx={{ color:"grey.medium", mr: 1 }} />
                      <Typography variant="body1">{data[0].blockgeo}</Typography>
                      <IconButton component="div" onClick={() => handleClose(index)}>
                        <CloseIcon fontSize="small" sx={{ color:"grey.medium" }} />
                      </IconButton>
                    </Box>
                )} {...a11yProps(index)} />
            ))}
        </Tabs>
        }
        <IconButton
            aria-label="open drawer"
            edge="end"
            onClick={() => {setDrawerOpen(!drawerOpen);}}
            sx={{ width: "32px", height: "32px", m: "4px" }}
        >
            <CloseIcon />
        </IconButton>
      </Box>
      {redistrictingdata.map((data, index) => (
        <TabPanel value={redistrictingdataid} index={index}>
          <FlexTable columns={Object.keys(data[0])} rows={data} />
        </TabPanel>
      ))}
    </Box>
  );
}
